<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure><i class="icon icon-icon_person"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Contacts <i class="icon icon-icon_arrow-right"></i> importation
                            </span>
                            <h1>Importation</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                        </div>
                        <div class="spacer"></div>
                    </header>

                    <main>

                      <div class="layout-import">
                        <div class="layout-import-header">

                          <fieldset>
                              <h3>Importation</h3>
                            <p class="headline"></p>
                              <!--
                              <form-text label="Commencer à la ligne" v-model="force_start_at"></form-text>
                              <form-text label="Fin de lignes" v-model="force_end_at"></form-text>
                              -->

                              <div class="import-excel">
                                  <div class="icon"></div>
                                  <div v-if="!fileName">
                                      Sélectionnez un fichier
                                  </div>
                                  <div v-if="fileName">
                                      <label>Votre fichier</label>
                                      <strong>{{ fileName }}</strong>
                                  </div>

                                  <input class="input" type="file" id="import" accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.csv" @change="fileSelected($event)">
                              </div>
                              <div style="text-align: right; display: flex; align-items: center; width: 100%;">
                                  <div style="flex: 1;">
                                      <div v-if="totalRow" class="progress-bar">
                                          <!--<span>Current {{ currentRow }} of {{ totalRow }}</span>-->
                                          <div class="bar">
                                              <div v-bind:style="{width: (currentRow*100/totalRow) + '%'}">{{ Math.round((currentRow*100/totalRow)) }}%</div>
                                          </div>
                                      </div>
                                  </div>
                                  <div style="margin-left: auto;">
                                      <button v-if="fileName" @click="upload($event)" class="btn bt-primary"><span>Importer</span></button>
                                  </div>
                              </div>
                          </fieldset>

                        </div>
                        <div class="layout-import-body">

                          <div class="layout-import-logs">
                                <div v-for="log in logs" v-bind:class="log.type">
                                    <div class="type">
                                        <i class="icon icon-icon_check" v-if="log.type != 'error'"></i>
                                        <i class="icon icon-icon_close" v-if="log.type == 'error'"></i>
                                    </div>
                                  <div>
                                    <div class="name">{{ log.name }}</div>
                                    <div class="line">{{ log.line }}</div>
                                    <div class="error" v-if="log.error">{{ log.error }}</div>
                                  </div>
                                    <div class="status">
                                        <span v-bind:class="log.status">{{ log.status }}</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                      </div>


                    </main>

                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import Service from './PersonService.js';
    import Import from '../../layouts/Import.vue';

    export default {
        extends: Import,
        data () {
            return {
                service: null
            }
        },
        mounted: function(){
            this.service = Service;
            this.initialize()
        },
        methods:{
            getResource: function(){
                return this.service
            }
        }
    }

</script>


// WEBPACK FOOTER //
// src/modules/person/Import.vue